var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('App.Footer.FindOutMore'))),_c('br'),_c('a',{attrs:{"href":"#","target":"_blank"}},[_vm._v("Flexopus - "+_vm._s(_vm.$t('App.Slogan')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }